import { en } from './en';
import { es } from './es';

export const i18n = () => ({
  en,
  es,
});
